import { getContactKeyFirstAndLastName } from './organizationContactsUtils';

export const _setNewOrganizationContactForm = (state, action) => {
  state.newOrganizationContactForm = action.payload;
};

export const _setOrgIdForContactForm = (state, action) => {
  state.orgId = action.payload;
};

export const _setCntId = (state, action) => {
  state.cntId = action.payload;
};

export const _setContactKey = (state, action) => {
  state.contactKey = action.payload;
};

export const _setHonorific = (state, action) => {
  state.honorific = action.payload;
};

export const _setFirstName = (state, action) => {
  state.firstName = action.payload;
  state.contactKey = getContactKeyFirstAndLastName(
    state.firstName,
    state.lastName,
    state.inactive
  );
};

export const _setLastName = (state, action) => {
  state.lastName = action.payload;
  state.contactKey = getContactKeyFirstAndLastName(
    state.firstName,
    state.lastName,
    state.inactive
  );
};
export const _setSuffix = (state, action) => {
  state.suffix = action.payload;
};
export const _setTitle = (state, action) => {
  state.title = action.payload;
};

export const _setWorkPhone = (state, action) => {
  state.workPhone = action.payload;
};

export const _setParoleOfficer = (state, action) => {
  state.paroleOfficer = action.payload;
};

export const _setInactive = (state, action) => {
  state.inactive = action.payload;
  state.contactKey = getContactKeyFirstAndLastName(
    state.firstName,
    state.lastName,
    state.inactive
  );
};

export const _setAddressCity = (state, action) => {
  state.addressCity = action.payload;
};

export const _setCreateDate = (state, action) => {
  state.createDate = action.payload;
};

export const _setEditdate = (state, action) => {
  state.editdate = action.payload;
};

export const _setContactEditedby = (state, action) => {
  state.contactEditedby = action.payload;
};

export const _setContactCreatedby = (state, action) => {
  state.contactCreatedby = action.payload;
};
